import React, { Fragment } from 'react';
import RegisterForm from '../components/RegisterForm'


export default class Register extends React.Component {

  render(){
    return (
      <Fragment>
        <RegisterForm />
      </Fragment>
    );
  }

}